export default {
  title: {
    en: 'Flash sale:',
  },
  subTitle: {
    en: 'left',
  },
  text: {
    en: `
      Today you have a unique chance to buy <br class="mobile" />
      our {title} for just <span class="brandColor">{price}</span>. <br />
      You will <span class="brandColor">save {discount} of the retail price.</span>
    `,
  },
  buttonTitle: {
    en: 'I want this deal',
  },
  discount: {
    en: '54% off',
  },
}
